import Controller from '@ember/controller';

export default class AuthenticatedProjectsShowProjectVersionsShowBouncesShowController extends Controller {}
